var PAGE_SIZE = 10;
var GENDERS = [{
  id: 0,
  label: "mapping.male",
  text: "Male",
  shortLabel: "M",
  value: 0
}, {
  id: 1,
  label: "mapping.female",
  text: "Female",
  shortLabel: "F",
  value: 1
}, {
  id: 2,
  label: "mapping.other",
  text: "Other",
  shortLabel: "O",
  value: 2
}];
var AI_INFERENCE = {
  WAITING_FOR_SCAN: 0,
  PROCESSING: 1,
  NEGATIVE: 2,
  POSITIVE: 3,
  URGENT: 4,
  REJECTED: -1,
  FAILED: -2,
  NA: -3
};
var STATUS_OPTIONS = [
// { label: 'Waiting for scan', value: AI_INFERENCE.WAITING_FOR_SCAN },
{
  label: "processing",
  value: AI_INFERENCE.PROCESSING
}, {
  label: "negative",
  value: AI_INFERENCE.NEGATIVE
}, {
  label: "positive",
  value: AI_INFERENCE.POSITIVE
}, {
  label: "critical",
  value: AI_INFERENCE.URGENT
}, {
  label: "invalid_scan",
  value: AI_INFERENCE.REJECTED
}, {
  label: "wte_processing_error",
  value: AI_INFERENCE.FAILED
}, {
  label: "not_available",
  value: AI_INFERENCE.NA
}];
var RN_COMM_CONST = {
  APP_READY: "APP_READY",
  FLUSH_COOKIES: "FLUSH_COOKIES",
  LOGIN: "LOGIN",
  SHARE: "SHARE",
  ENV_SELECTION: "ENV_SELECTION",
  REGION_URL: "REGION_URL",
  OPEN_APP_SETTINGS: "OPEN_APP_SETTINGS"
};
var SCREENS = {
  WORKLIST: "patients",
  VIEWER: "viewer",
  LUNGCANCER: "lungcancer",
  EXPANDED_WORKLIST: "worklist"
};
var MESSAGE_TYPES = {
  MEDIA: "MEDIA",
  STUDY: "STUDY",
  REPORT: "REPORT",
  FORM: "FORM",
  QUESTION: "QUESTION",
  ANSWER: "ANSWER",
  LETTER: "LETTER",
  RADIOLOGY_REPORT: "RADIOLOGY_REPORT",
  AIRA_SUMMARY: "AIRA_SUMMARY",
  AIRA_LOG: "AIRA_LOG"
};
var MEDIA_TYPES = {
  IMAGE: "IMAGE",
  DOCUMENT: "DOCUMENT",
  AUDIO: "AUDIO",
  NA: "NA"
};
var SELECTED_MEDIA_TYPE = ["IMAGE", "DOCUMENT", "STUDY", "REPORT", "FORM", "AUDIO"];
var IMAGE_TYPES = ["jpg", "jpeg", "png", "webp"];
var DOC_TYPES = ["pdf", "msword", "doc", "docx", "xls", "xlsx"];
var AUDIO_TYPES = ["mp3", "mpga", "weba", "webm"];
var PLATFORMS = {
  ANDROID: 0,
  PWA: 1,
  IOS: 2
};
var FORMS = {
  STROKE_NIHSS: "nihss",
  LUNG_CANCER: "lung_cancer",
  RADIOLOGY_ENCOUNTER: "mt_sinai_radiology_encounter",
  PATIENT_ELIGIBILITY: "mt_sinai_eligibility",
  QTRACK_CBNAAT_CLT: "qtrack_cbnaat_clt",
  STROKE_CLINICAL: "stroke_clinical",
  CXR_DATA: "cxr_data",
  LUNG_CANCER_PATHWAY: "lung_cancer_pathway",
  DISCORDANCE: "discordance",
  CT_REFERRAL_AND_AQC: "ct_referral_and_aqc",
  PATIENT_DATA: "patient_data",
  QTRACK_GENEXPERT_CLT: "qtrack_genexpert_clt",
  SYMPTOMS_NEW: "symptoms_new",
  RESIDENCE_DETAILS: "residence_details",
  CARITAS_CONFIRMATION_TEST_CBNAAT: "caritas_confirmation_test_cbnaat",
  CT_DATA: "ct_data",
  TB_VOUCHER: "tb_voucher",
  COUGH_AI_INTERPRETATION: "cough_ai_interpretation",
  DEMOGRAPHIC_DETAILS: "demographic_details",
  PATIENT_SYMPTOMS_MYLABS: "patient_symptoms_mylabs",
  CT_BIOPSY: "ct_biopsy",
  TB_DIAGNOSIS_MYLABS: "tb_diagnosis_mylabs",
  CARITAS_CONFIRMATION_TEST_AFB_SMEAR: "caritas_confirmation_test_afb_smear",
  RISK_GROUPS_NEW: "risk_groups_new",
  SYMPTOMS: "symptoms",
  MRI_REPORT_SUMMARY: "mri_report_summary",
  PATIENT_RISK_GROUPS_MYLABS: "patient_risk_groups_mylabs",
  PAEDIATRICS_TB_CALCULATOR: "paediatrics_tb_calculator",
  RISK_GROUPS: "risk_groups",
  HIV: "hiv",
  COPD_CAT_ASSESSMENT_FORM: "copd_cat_assessment_form"
};
var NOTIFICATION_EVENTS = {
  NEW_PATIENT: 0,
  POSITIVE_FINDINGS: 2,
  NEGATIVE_FINDINGS: 3,
  REPORT_UPDATE: 4,
  STROKE_INITIATED: 5,
  PATIENT_SHARED: 7
};
var FORM_FIELDS = {
  DUAL_NUMBER: "dual_number",
  NUMBER: "number",
  MULTISELECT: "multiselect",
  CHECKBOX: "check_box",
  SINGLESELECT: "singleselect",
  DATETIME: "datetime",
  LKWT: "lkwt"
};
var DEEFAULT_FILTER = {
  isFilterApplied: false,
  data: null,
  label: ""
};
var DICOM_METADATA_TAGS = {
  SOPInstanceUID: "x00080018",
  SOPClassUID: "x00080016",
  StudyInstanceUID: "x0020000d",
  SeriesInstanceUID: "x0020000e",
  Modality: "x00080060",
  PatientID: "x00100020",
  AccessionNumber: "x00080050",
  PatientName: "x00100010",
  PatientGender: "x00100040",
  PatientAge: "x00101010",
  StudyDescription: "x00081030",
  SeriesDescription: "x0008103e",
  StudyDate: "x00080020"
};
var REQUIRED_DICOM_METADATA = ["SOPInstanceUID", "SOPClassUID", "SeriesInstanceUID", "StudyInstanceUID", "Modality", "PatientID"];
var TESTING_REGIONS = ["localhost", "dev2-app.qure.ai", "alpha-app.qure.ai", "beta-app.qure.ai", "vercel.app"];
var COUNTRY_CODE = "+91";
var PERSISTED = {
  isFullWidthWorklist: "isFullWidthWorklist",
  isWorklistCollapsed: "isWorklistCollapsed",
  isSummaryCollapsed: "isSummaryCollapsed",
  filterObj: "filterObj_new",
  savedFilterData: "savedFilterData_new",
  sortParams: "sortParams",
  isDarkMode: "isDarkMode",
  isSwiftReportModeEnabled: "isSwiftReportModeEnabled",
  notificationPromptDismiss: "notificationPromptDismiss",
  fcmToken: "fcmToken",
  redirectAfterLogin: "redirectAfterLogin",
  patientSearch: "patientSearch",
  otpLoginSuccess: "otpLoginSuccess",
  nextSteps: "nextSteps",
  requestedWorkspaceData: "requestedWorkspaceData",
  mixpanelEvents: "mixpanelEvents"
};
var DEFAULT_FILTER_NAME = {
  negativeCXR: "Review Negative CXR"
};
var MPPS_STATUS = {
  DISCONTINUED: "DISCONTINUED",
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN PROGRESS",
  REGISTERED: "REGISTERED"
};
var TERMS_OF_USE_VERSION = "2.0.4";
var UPLOAD_UI_STATE = {
  BROWSE_FILE: "BROWSE_FILE",
  CROP_FILE: "CROP_FILE",
  CROP_COMPLETE: "CROP_COMPLETE"
};
var UPLOAD_STATE = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  FAILED: "FAILED",
  FAILED_LOW_RES: "FAILED_LOW_RES"
};
var GATEWAY_TIME = {
  TIME_DIFFERENCE: 16
};
var ERROR_TYPE = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  VIEWER_FEEDBACK: "VIEWER_FEEDBACK"
};
var AUTO_SHARING_SECTIONS = {
  modalities: ["modality"],
  findings: ["qxr", "qer", "qct", "qmsk"],
  patient_status: ["emergency", "forms"]
};
var PULL_TO_REFRESH = {
  resistance: 3,
  maxPullDownDistance: 100
};
var SYNC_STATUS = {
  ONPREMISE: {
    SYNCED: "SYNCED",
    IN_PROGESS: "IN_PROGRESS",
    NO_INTERNET: "NO_INTERNET"
  },
  CLOUD: {
    UNREAD: "UNREAD",
    READ: "READ"
  },
  ERROR: {
    DISABLED: "sync_disabled",
    NEVER_STARTED: "never_started"
  }
};
var FORM_NAMES = {
  qxr: "Tuberculosis",
  qer: "Neurology - Stroke evaluation",
  lung_cancer: "Lung Cancer",
  qct: "qCT",
  "default": "Clinical Forms",
  mylabs: "Forms",
  copd: "COPD"
};
var SETTINGS = {
  NOTIFICATIONS: "notifications",
  AUTOMATED_SHARING: "automated-sharing",
  USER_GROUPS: "user-groups",
  GATEWAY: "gateway",
  FORM_TEMPLATES: "form-templates",
  REPORT_TEMPLATE: "report-template",
  MODALITY_CONNECT: "modality-connect",
  THEME: "theme",
  WORKLIST_TAGS: "worklist-tags",
  WORKSPACE_MANAGEMENT: "workspace-management",
  SITE_MANAGEMENT: "site-management",
  EXPORT_DATA: "export-data",
  REGION: "region",
  TERMS_OF_USE: "terms-of-use",
  REMOTE_ACCESS: "remote-access",
  SCAN_TO_CONNECT: "scan_to_connect",
  DISK_MANAGEMENT: "disk-management",
  LICENSE_MANAGER: "license",
  CUSTOM_TAGS_MANAGEMENT: "custom-tags-management",
  LETTER_TEMPLATE: "letter-template"
};
var WORKSPACE_USER_ROLES = {
  WORKSPACE_PATIENT_READ: "WORKSPACE_PATIENT_READ",
  WORKSPACE_PATIENT_WRITE: "WORKSPACE_PATIENT_WRITE",
  WORKSPACE_PATIENT_UPLOAD: "WORKSPACE_PATIENT_UPLOAD",
  WORKSPACE_AUTOSHARING: "WORKSPACE_AUTOSHARING",
  WORKSPACE_MANAGEMENT: "WORKSPACE_MANAGEMENT",
  WORKSPACE_EXPORT_DATA: "WORKSPACE_EXPORT_DATA",
  WORKSPACE_DASHBOARD: "WORKSPACE_DASHBOARD",
  WORKSPACE_GATEWAY_INDICATORS: "WORKSPACE_GATEWAY_INDICATORS",
  WORKSPACE_FORM_SETTINGS: "WORKSPACE_FORM_SETTINGS",
  WORKSPACE_APPROVE_SITE_ARTIFACTS: "WORKSPACE_APPROVE_SITE_ARTIFACTS"
};
var VIEWER_LABEL = {
  ZOOM: "Zoom",
  MAGNIFY: "Magnify",
  WINDOW_LEVEL: "Window Level",
  WINDOW_LEVEL_PRESET: "WindowLevel",
  ALTERNATE_NAME_FOR_WINDOW_LEVEL: "Wwwc",
  LENGTH: "Length",
  BIDIRECTIONAL: "Bidirectional",
  ANNOTATION: "Annotation",
  ELLIPSE: "Ellipse",
  ARROW_ANNOTATION: "ArrowAnnotate",
  ELLIPTICALROI: "EllipticalROI",
  ANGLE: "Angle",
  ROTATE_RIGHT: "Rotate Right",
  ROTATE_LEFT: "Rotate Left",
  FLIP_HORIZONTAL: "Flip Horizontal",
  FLIP_VERTICAL: "Flip Vertical",
  INVERT: "Invert",
  PAN: "Pan",
  GRID_LAYOUT: "Grid Layout",
  PROBE: "Probe",
  STACK_SCROLL: "Stack Scroll",
  CINE_TOOL: "Cine tool",
  RESET: "Reset",
  DEFAULT: "Default",
  SOFT_TISSUE: "Soft tissue",
  LUNG: "Lung",
  LIVER: "Liver",
  BONE: "Bone",
  BRAIN: "Brain",
  SUBDURAL: "Subdural",
  STROKE: "Stroke",
  TEMPORAL_BONES: "Temporal Bones"
};
var FORM_FIELD_TYPES = {
  multiple_choice: "string[]",
  textarea: "string",
  choice: "string",
  nihss_choice: "string",
  dropdown: "string"
};
export default {
  PAGE_SIZE: PAGE_SIZE,
  GENDERS: GENDERS,
  AI_INFERENCE: AI_INFERENCE,
  RN_COMM_CONST: RN_COMM_CONST,
  STATUS_OPTIONS: STATUS_OPTIONS,
  SCREENS: SCREENS,
  MESSAGE_TYPES: MESSAGE_TYPES,
  MEDIA_TYPES: MEDIA_TYPES,
  IMAGE_TYPES: IMAGE_TYPES,
  DOC_TYPES: DOC_TYPES,
  AUDIO_TYPES: AUDIO_TYPES,
  PLATFORMS: PLATFORMS,
  FORMS: FORMS,
  NOTIFICATION_EVENTS: NOTIFICATION_EVENTS,
  FORM_FIELDS: FORM_FIELDS,
  DEEFAULT_FILTER: DEEFAULT_FILTER,
  DICOM_METADATA_TAGS: DICOM_METADATA_TAGS,
  REQUIRED_DICOM_METADATA: REQUIRED_DICOM_METADATA,
  PERSISTED: PERSISTED,
  TERMS_OF_USE_VERSION: TERMS_OF_USE_VERSION,
  DEFAULT_FILTER_NAME: DEFAULT_FILTER_NAME,
  MPPS_STATUS: MPPS_STATUS,
  UPLOAD_UI_STATE: UPLOAD_UI_STATE,
  UPLOAD_STATE: UPLOAD_STATE,
  GATEWAY_TIME: GATEWAY_TIME,
  ERROR_TYPE: ERROR_TYPE,
  AUTO_SHARING_SECTIONS: AUTO_SHARING_SECTIONS,
  PULL_TO_REFRESH: PULL_TO_REFRESH,
  SELECTED_MEDIA_TYPE: SELECTED_MEDIA_TYPE,
  SYNC_STATUS: SYNC_STATUS,
  FORM_NAMES: FORM_NAMES,
  SETTINGS: SETTINGS,
  COUNTRY_CODE: COUNTRY_CODE,
  TESTING_REGIONS: TESTING_REGIONS,
  WORKSPACE_USER_ROLES: WORKSPACE_USER_ROLES,
  VIEWER_LABEL: VIEWER_LABEL,
  FORM_FIELD_TYPES: FORM_FIELD_TYPES
};